module.exports = __webpack_public_path__ + "img/front-white-arrow.b5c05c4.svg";